/* jslint browser: true */
/* global document */
import React, { Component } from 'react';
import ReactTable           from 'react-table';
import Modal                from 'react-modal';
import axios                from 'axios';
import 'react-table/react-table.css';
import FormMenu             from './FormMenu';
import { removeFromArray }  from '../helpers';
import { apiUrl }           from '../lib/constants';

class MenusList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList : [],
            type     : ['', 'Petit-Déjeuner', 'Collation de 10h', 'Déjeuner', 'Collation de 16h', 'Dîner', 'Déjeuner rapide'],
            columns  :
            [
                {
                    id         : 'id',
                    Header     : 'ID',
                    width      : 50,
                    accessor   : d => d.menu.id_menu,
                    sortable   : true,
                    filterable : true,
                }, {
                    id       : 'nom',
                    Header   : 'Nom du menu',
                    accessor : d => d.menu.nom,
                    sortable : true,
                }, {
                    id         : 'actif',
                    Header     : 'Actif',
                    sortable   : true,
                    filterable : true,
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" id="actif" value="actif" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.menu.actif,
                    Cell     : _props => (
                        <span className="actif">
                            <input readOnly type="checkbox" value="actif" disabled checked={_props.value} />
                        </span>
                    ),
                }, {
                    id       : 'type',
                    Header   : 'Type de repas',
                    accessor : d => this.state.type[d.menu.type],

                }, {
                    id         : 'global',
                    sortable   : true,
                    filterable : true,
                    Header     : 'Global',
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" value="Surcharge globale" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.problemes.indexOf('1'),
                    Cell     : _props => (
                        <span className="global">
                            <input readOnly type="checkbox" value="global" disabled checked={_props.value !== -1} />
                        </span>
                    ),
                }, {
                    id         : 'androide',
                    sortable   : true,
                    filterable : true,
                    Header     : 'Androïde',
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" value="Surcharge androïde" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.problemes.indexOf('2'),
                    Cell     : _props => (
                        <span className="androide">
                            <input readOnly type="checkbox" value="androide" disabled checked={_props.value !== -1} />
                        </span>
                    ),
                }, {
                    id         : 'gynoide',
                    sortable   : true,
                    filterable : true,
                    Header     : 'Gynoïde',
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" value="Cellulite gynoïde" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.problemes.indexOf('3'),
                    Cell     : _props => (
                        <span className="gynoide">
                            <input readOnly type="checkbox" value="gynoide" disabled checked={_props.value !== -1} />
                        </span>
                    ),
                }, {
                    id         : 'metabolique',
                    sortable   : true,
                    filterable : true,
                    Header     : 'Métabolique',
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" value="Cellulite métabolique" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.problemes.indexOf('4'),
                    Cell     : _props => (
                        <span className="metabolique">
                            <input readOnly type="checkbox" value="metabolique" disabled checked={_props.value !== -1} />
                        </span>
                    ),
                }, {
                    id         : 'fibreuse',
                    sortable   : true,
                    filterable : true,
                    Header     : 'Fibreuse',
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" value="Cellulite fibreuse" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.problemes.indexOf('5'),
                    Cell     : _props => (
                        <span className="fibreuse">
                            <input readOnly type="checkbox" value="fibreuse" disabled checked={_props.value !== -1} />
                        </span>
                    ),
                }, {
                    id         : 'cutane',
                    sortable   : true,
                    filterable : true,
                    Header     : 'Cutané',
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" value="Relâchement cutané" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.problemes.indexOf('6'),
                    Cell     : _props => (
                        <span className="cutane">
                            <input readOnly type="checkbox" value="cutane" disabled checked={_props.value !== -1} />
                        </span>
                    ),
                }, {
                    id         : 'acne',
                    sortable   : true,
                    filterable : true,
                    Header     : 'Acné',
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" value="Peau grasse / acné" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.problemes,
                    Cell     : _props => (
                        <span className="acne">
                            <input readOnly type="checkbox" value="acne" disabled checked={_props.value.indexOf('7') !== -1} />
                        </span>
                    ),
                }, {
                    id         : 'rides',
                    sortable   : true,
                    filterable : true,
                    Header     : 'Rides',
                    Filter     : () => (
                        <span>
                            <input type="checkbox" name="filter" value="Rides" onChange={e => this.onFilterChange(e)} />
                        </span>
                    ),
                    accessor : d => d.problemes,
                    Cell     : _props => (
                        <span className="rides" width="20%">
                            <input readOnly type="checkbox" value="rides" disabled checked={_props.value.indexOf('8') !== -1} />
                        </span>
                    ),
                },
            ],
            problemes   : [],
            filters     : [],
            isActive    : false,
            data        : [],
            isOpenModal : false,
            menuId      : undefined,
        };
        this.closeModal     = this.closeModal.bind(this);
        this.openModal      = this.openModal.bind(this);
        this.filterData     = this.filterData.bind(this);
        this.loadData       = this.loadData.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidMount() {
        axios.get(`${apiUrl}/api/v1/isAdmin`)
            .then((response) => {
                if (response.data === 0) {
                    window.location.href = '/login?c';
                }
            });
    }

    onFilterChange(e) {
        let filters = [];
        let data = this.state.menuList;
        if (e.target.value === 'actif' && e.target.checked) {
            data = data.filter(menu => menu.menu.actif);
            this.setState({ data, isActive: true });
            return false;
        } else if (e.target.value === 'actif' && !e.target.checked) {
            data = data.filter(menu => !menu.menu.actif);
            this.setState({ data });
            return false;
        } else if (e.target.checked) {
            filters = this.state.filters;
            filters.push(e.target.value);
        } else {
            filters = removeFromArray(this.state.filters, e.target.value);
            this.setState({ data, filters });
        }
        filters.map((filter) => {
            if (this.state.isActive) {
                const isActive = document.querySelector('#actif').checked ? 1 : 0;
                data = data.filter(menu => menu.problemes.indexOf(String(this.state.problemes.findIndex(probleme => probleme.nom === filter) + 1)) !== -1 && menu.menu.actif === isActive);
            } else {
                data = data.filter(menu => menu.problemes.indexOf(String(this.state.problemes.findIndex(probleme => probleme.nom === filter) + 1)) !== -1);
            }
            return data;
        });
        this.setState({
            data,
            filters,
        });
        return false;
    }

    loadData() {
        axios.get(apiUrl + '/api/v1/admin/menu').then((response) => {
            this.setState({ menuList: response.data, data: response.data });
        });
        axios.get(`${apiUrl}/api/v1/probleme`)
            .then((response) => {
                this.setState({
                    problemes : response.data,
                });
            });
    }

    /**
     * Filtre le tableau de professionnels (this.state.menuList) en fonction de la valeur saisi dans l'input Établissement (e.target.value)
     * @param  {Event} e - Evenement capté par le onChange
     */
    filterData() {
        const query = document.querySelector('#search').value;
        const queryType = document.querySelector('#searchByComposition').checked;
        if (queryType) {
            this.setState({
                data : this.state.menuList.filter(menu => menu.menu.compositions.toLowerCase().indexOf(query.toLowerCase()) !== -1),
            });
        } else {
            this.setState({
                data : this.state.menuList.filter(menu => menu.menu.nom.toLowerCase().indexOf(query.toLowerCase()) !== -1),
            });
        }
    }

    /**
     * Permet d'ouvrir la popup contenant de formulaire de création ou d'edition (selon si on a selectionner une ligne du tableau)
     * @param  {Object} [row=undefined] - Contient toutes les infos de la ligne (<tr />) séléctionnée (en l'occurence ici le menu)
     */
    openModal(row = undefined) {
        if (row === undefined) {
            this.setState({ isOpenModal: true, menuId: row });
        } else {
            this.setState({ isOpenModal: true, menuId: row.original.menu.id_menu });
        }
    }

    /**
     * Permet de fermet la popup et de supprimer l'ID du menu selectionné
     */
    closeModal() {
        this.setState({ isOpenModal: false, menuId: undefined });
    }

    render() {
        return (
            <div className="pro-list-wrapper">
                <div className="top-part">
                    <h3 className="pro-list-title">Gestion des menus</h3>
                    <button className="btn myBtn pull-right" style={{ marginTop: '0' }} onClick={() => this.openModal()}>Ajouter</button>
                    <div style={{ whiteSpace: 'nowrap' }}>
                        <input type="text" name="search" id="search" onChange={e => this.filterData(e)} />
                        <input type="checkbox" name="searchByComposition" id="searchByComposition" onChange={e => this.filterData(e)} />
                        <label htmlFor="searchByComposition">Rechercher dans les compositions</label>
                    </div>
                </div>
                <ReactTable
                    data={this.state.data}
                    defaultPageSize={10}
                    previousText="Précédent"
                    nextText="Suivant"
                    loadingText="Chargement..."
                    noDataText="Aucune informations"
                    ofText="sur"
                    rowsText="lignes"
                    showPageSizeOptions={false}
                    style={{ margin: '0 10px' }}
                    columns={this.state.columns}
                    getTrProps={(state, rowInfo) => ({
                        onClick : () => this.openModal(rowInfo),
                    })}
                />
                <Modal
                    isOpen={this.state.isOpenModal}
                    onRequestClose={this.closeModal}
                    shouldCloseOnOverlayClick={false}
                    style={{
                        overlay : {
                            backgroundColor : 'rgba(0, 0, 0, 0.75)',
                            zIndex          : 9,
                        },
                        content : {
                            position     : 'absolute',
                            border       : '1px solid rgb(204, 204, 204)',
                            background   : 'rgb(249, 249, 249)',
                            overflow     : 'hidden',
                            overflowY    : 'unset',
                            borderRadius : '4px',
                            outline      : 'none',
                            padding      : 'unset',
                            bottom       : 'unset',
                            maxHeight    : '95vh',
                            width        : '100%',
                            maxWidth     : '900px',
                            top          : '50%',
                            left         : '50%',
                            transform    : 'translate(-50%, -50%)',
                        },
                    }}
                >
                    <div className="content-box">
                        <div className="form-header-pro">
                            {
                                this.state.menuId !== undefined ?
                                    <h3>Édition d&apos;un menu</h3> :
                                    <h3>Création d&apos;un menu</h3>
                            }
                            <span role="button" tabIndex="0" onClick={this.closeModal}>
                                <i
                                    className="fa fa-close fa-2x"
                                    style={{
                                        color    : '#fff',
                                        position : 'absolute',
                                        top      : '3px',
                                        right    : '5px',
                                        cursor   : 'pointer',
                                    }}
                                />
                            </span>
                        </div>
                        {
                            this.state.menuId === undefined ?
                                <FormMenu closeModal={this.closeModal} loadData={this.loadData} /> :
                                <FormMenu closeModal={this.closeModal} menuId={this.state.menuId} loadData={this.loadData} />

                        }
                    </div>
                </Modal>
            </div>
        );
    }
}

export default MenusList;



// WEBPACK FOOTER //
// ./src/components/MenusList.js